"use client";
import classNames from "classnames";
import styles from "./styles.module.scss";
import { useEffect, useRef } from "react";

import Link from "next/link";

export default function Component() {
  const navBarRef = useRef(null);

  const tabLineRef = useRef(null);

  const productDetaiTabRef = useRef(null);
  const reviewsTabRef = useRef(null);
  const discoverMoreTabRef = useRef(null);
  const bikeFitmentTabRef = useRef(null);
  const deliveryAndReturnsTabRef = useRef(null);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    document.getElementById("footer").classList.add("mb-[112px]");
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener("click", function (event) {
        event.preventDefault();

        const target = document.querySelector(this.getAttribute("href"));
        if (target) {
          const targetTop = target.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: targetTop,
            behavior: "smooth",
          });
        }
      });
    });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.getElementById("footer")?.classList.remove("mb-[112px]");
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.removeEventListener("click", function (event) {});
      });
    };
  }, []);

  const handleScroll = () => {
    const productDetailSection = document.getElementById("productDetailSection");
    const reviewsSection = document.getElementById("reviews");
    const discoverSection = document.getElementById("discover");
    const fitmentSection = document.getElementById("fitment");
    const deliveryAndReturnsSection = document.getElementById("delivery-and-returns");

    const distanceToBottom = document.getElementById("productDetailSection").getBoundingClientRect().bottom;
    if (distanceToBottom <= 0) {
      navBarRef.current.classList.add("fixed");
      productDetailSection.classList.add("mt-[80px]");
    } else {
      navBarRef.current.classList.remove("fixed");
      productDetailSection.classList.remove("mt-[80px]");
    }
    if (deliveryAndReturnsSection && deliveryAndReturnsSection.getBoundingClientRect().bottom < 0) {
      navBarRef.current.classList.add("hidden");
    } else {
      navBarRef.current.classList.remove("hidden");
    }

    const productDetailTabWidth = productDetaiTabRef.current.getBoundingClientRect().width;
    const productDetailTabChildWidth = productDetaiTabRef.current.querySelector("p").getBoundingClientRect().width;

    const reviewsTabWidth = reviewsTabRef.current.getBoundingClientRect().width;
    const reviewsTabChildWidth = reviewsTabRef.current.querySelector("p").getBoundingClientRect().width;

    const discoverMoreTabWidth = discoverMoreTabRef.current.getBoundingClientRect().width;
    const discoverMoreTabChildWidth = discoverMoreTabRef.current.querySelector("p").getBoundingClientRect().width;

    const bikeFitmentTabWidth = bikeFitmentTabRef.current.getBoundingClientRect().width;
    const bikeFitmentTabChildWidth = bikeFitmentTabRef.current.querySelector("p").getBoundingClientRect().width;

    const deliveryAndReturnsTabWidth = deliveryAndReturnsTabRef.current.getBoundingClientRect().width;
    const deliveryAndReturnsTabChildWidth = deliveryAndReturnsTabRef.current
      .querySelector("p")
      .getBoundingClientRect().width;

    const navBarRefHeight = navBarRef.current.getBoundingClientRect().height;
    var width = productDetailTabChildWidth;
    var left = 0;

    if (productDetailSection && parseInt(productDetailSection.getBoundingClientRect().top) <= navBarRefHeight) {
      left = 0;
      width = productDetailTabChildWidth;
    }
    if (reviewsSection && parseInt(reviewsSection.getBoundingClientRect().top) <= navBarRefHeight) {
      left = productDetailTabWidth;
      width = reviewsTabChildWidth;
    }
    if (discoverSection && parseInt(discoverSection.getBoundingClientRect().top) <= navBarRefHeight) {
      left = productDetailTabWidth + reviewsTabWidth;
      width = discoverMoreTabChildWidth;
    }
    if (fitmentSection && parseInt(fitmentSection.getBoundingClientRect().top) <= navBarRefHeight) {
      left = productDetailTabWidth + reviewsTabWidth + discoverMoreTabWidth;
      width = bikeFitmentTabChildWidth;
    }
    if (
      deliveryAndReturnsSection &&
      parseInt(deliveryAndReturnsSection.getBoundingClientRect().top) <= navBarRefHeight
    ) {
      left = productDetailTabWidth + reviewsTabWidth + discoverMoreTabWidth + bikeFitmentTabWidth;
      width = deliveryAndReturnsTabChildWidth;
    }
    navBarRef.current.scrollTo({ left: left, behavior: "smooth" });
    tabLineRef.current.style.left = `${left}px`;
    tabLineRef.current.style.width = `${width}px`;
  };

  return (
    <>
      <div className="relative">
        <div
          ref={navBarRef}
          className={classNames(
            "w-full bg-white flex border-y-[1px] border-grey-200 px-[16px] md:px-8 lg:px-[100px] top-0 z-10 overflow-x-auto font-roboto",
            styles.navBar
          )}
        >
          <Link ref={productDetaiTabRef} href="#product-description" className="pr-8">
            <p className="w-max text-lg font-bold py-4">Product Detail</p>
          </Link>
          <Link ref={reviewsTabRef} href="#reviews" className="pr-8">
            <p className="w-max text-lg font-bold py-4">Reviews</p>
          </Link>
          <Link ref={discoverMoreTabRef} href="#discover" className="pr-8">
            <p className="w-max text-lg font-bold py-4">Discover More</p>
          </Link>
          <Link id="fitmentTab" ref={bikeFitmentTabRef} href="#fitment" className="pr-8 hidden">
            <p className="w-max text-lg font-bold py-4">Bike fitment</p>
          </Link>
          <Link ref={deliveryAndReturnsTabRef} href="#delivery-and-returns" className="pr-8">
            <p className="w-max text-lg font-bold py-4">Delivery & Returns</p>
          </Link>
          <div ref={tabLineRef} className={classNames(styles.tabLine)}></div>
        </div>
      </div>
    </>
  );
}
